import { render, staticRenderFns } from "./ContentDeclared.vue?vue&type=template&id=71f79504"
import script from "./ContentDeclared.vue?vue&type=script&lang=js"
export * from "./ContentDeclared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports